<mat-chip selectable [selected]="value" (click)="value=!value"  [ngClass]="{'accent-bg': value, 'white-fg': value}">
    <mat-icon class="font-size-18" style="line-height: 23px" *ngIf="this.value">
        checkbox
    </mat-icon>
    <mat-icon class="font-size-18" style="line-height: 23px" *ngIf="!this.value">
        check_box_outline_blank
    </mat-icon>
    <span>{{name}}</span>
</mat-chip>